import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import initCareerActions from '@finn-no/redux-career';
import radio from 'radio';
import careerPaths from './career-paths';
import CareerPreferencesAdView from './views/CareerPreferencesAdView.jsx';
import CareerPreferencesMarketPageView from './views/CareerPreferencesMarketPageView.jsx';
import store from './store';

const SHOW_CHANNEL_NAME = 'careerPreferences:show';
const REFRESH_ADS_CHANNEL_NAME = 'recommendations:withCP:fetch';

const $followApp = document.querySelector('#react-app-career-preferences');
const $marketPromptApp = document.querySelector(
    '#react-app-career-preferences-market'
);

initCareerActions(careerPaths);

if ($followApp) {
    // wait for radio event to render popover
    radio(SHOW_CHANNEL_NAME).subscribe(companyName => {
        render(
            <CareerPreferencesAdView
                companyName={companyName}
                onDismiss={() => ReactDOM.unmountComponentAtNode($followApp)}
            />,
            $followApp
        );
    });
}

if ($marketPromptApp) {
    render(
        <CareerPreferencesMarketPageView
            onDismiss={onDismissMarketPageApp}
            onComplete={onCompletePreferencesPrompt}
        />,
        $marketPromptApp
    );
}

function render(tree, el) {
    ReactDOM.render(<Provider store={store}>{tree}</Provider>, el);
}

function onDismissMarketPageApp() {
    ReactDOM.unmountComponentAtNode($marketPromptApp);
}

function onCompletePreferencesPrompt() {
    radio(REFRESH_ADS_CHANNEL_NAME).broadcast();
}



// WEBPACK FOOTER //
// ./reactEntryPoint.jsx